<template>
  <router-view />
</template>
<script>
export default {};
</script>
<style lang="scss">
@import "src/assets/scss/auth-layout.scss";
</style>
